// extracted by mini-css-extract-plugin
export default {"form":"NovoCliente_form__aa5pt","areaBtn":"NovoCliente_areaBtn__fsYAk","btn":"NovoCliente_btn__2tbEx"};